import { AssetsPage } from '@features/assets/components/AssetsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/assets/printers')({
    component: () => <AssetsPage kind="printers" />,
    staticData: {
        crumb: {
            label: 'Printers',
        },
    },
})
